import type { FieldValues } from 'react-hook-form'

import { Heading } from '@circlefin/components'
import { createFormSelectCard } from '@circlefin/form/Form.SelectCard/Form.SelectCard'

import type { FormSelectCardProps } from '@circlefin/form/Form.SelectCard/Form.SelectCard'

interface RadioCardGroupOptionProps<T extends FieldValues>
  extends Omit<FormSelectCardProps<T>, 'name'> {
  /**
   * Field name.
   */
  name: string
}

const RadioCard = createFormSelectCard()

/**
 * Circle L3 Onboarding Radio Card Group Option.
 */
export function RadioCardGroupOption<T extends FieldValues>({
  label,
  name,
  value,
  ...props
}: Readonly<RadioCardGroupOptionProps<T>>) {
  return (
    <RadioCard
      className="grow"
      data-form-field-name={name}
      data-form-field-option={value}
      data-form-field-type="conditional"
      data-testid={`radio-card-${value}`}
      label={label}
      name={name}
      value={value}
      variant="primary/sm"
      {...props}
    >
      <Heading variant="title/sm">
        <Heading.Header>{label}</Heading.Header>
      </Heading>
    </RadioCard>
  )
}
